import { uid } from '../../../../lib/uid';

/*
  Relations a 201 file genuinely has to carry beyond the four CS Form 212 prints, which is the
  argument for the catalog existing at all. Synthetic vocabulary would be the wrong call here:
  unlike a person's name, a relation label never leaves `rsys_` and never lands in the identity
  store, and an unreadable one would make the generated catalog worse at the one job it has —
  showing what this list is for.
*/
const KINDS = [
  'Guardian',
  'Step-father',
  'Step-mother',
  'Father-in-law',
  'Mother-in-law',
  'Sibling',
  'Ward',
];

/**
 * A sample family relation, so the create form fills in one click.
 *
 * The name is suffixed because it is unique among active rows — Autogenerate is most useful
 * clicked repeatedly, and without a suffix the second click would return the row the first one
 * made rather than adding anything.
 *
 * **The flags stay at their least surprising values.** A generator that randomised
 * `requiresDateOfBirth` would produce a different form on every click, and a generator the
 * reader cannot predict is worse than one that fills less — the same rule that keeps a
 * step-adding flag at its default.
 */
export function sampleFamilyRelation(): {
  name: string;
  description: string;
  guidance: string;
  allowsMultiple: boolean;
  requiresDateOfBirth: boolean;
  collectsOccupation: boolean;
} {
  const tag = uid().slice(0, 4).toUpperCase();
  const kind = KINDS[Math.floor(Math.random() * KINDS.length)];

  return {
    name: `${kind} ${tag}`,
    description: `Sample relation ${tag}. Delete it once the real list is in.`,
    guidance: '',
    allowsMultiple: true,
    requiresDateOfBirth: false,
    collectsOccupation: false,
  };
}
